var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-card flex-centerize",style:(`min-height: ${_vm.width + 8}px; min-width: ${_vm.width + 8}px`)},[(_vm.iconName)?_c('SIcon',{attrs:{"width":_vm.width,"name":_vm.iconName}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }